GatiServerGame = function () {
  var base = new GatiServer();
  GatiServer.call(this, base);
  this.inFS = false;
  this.fsIndex = 0;
  this.fsWinnings = 0;
  this.fsCount = 0;
  this.respinsAdded = 0;
  this.gambleForce = undefined;
  this.getGambleForce = false;

  this.addGameConfigToQueueBase = this.addGameConfigToQueue;
  this.addGameConfigToQueue = this.addGameConfigToQueueDerived;
  this.addRecoveryToQueueBase = this.addRecoveryToQueue;
  this.addRecoveryToQueue = this.addRecoveryToQueueDerived;
  this.restorePreviousWagersBase = this.restorePreviousWagers;
  this.restorePreviousWagers = this.restorePreviousWagersDerived;
  this.startGameBase = this.startGame;
  this.startGame = this.startGameDerived;
  this._inBuyABonus = false;
  this._inLuckyBet = false;
  this._inMaxPlay = false;
  this._localRngSeed = -1;
  this._trailPosition = 0;
  this._trailLevel = 1;
  this._trailPositionIncreased = false;

  this.freeSpinsCostMaxMultiplier;
  this.freeSpinsCostMultiplier;
  this.luckyBetCostMultiplier;

  this._totalWinnings = 0;
  this._numLines = 10;
};

GatiServerGame.prototype = Object.create(GatiServer.prototype);

GatiServerGame.prototype.getRandomForGui = function () {
  let rangeExplicit = 32768; // it is the default inside the mersenneTwister but in case they change it I am defining it here
  let r = MarsenneTwister.rand(rangeExplicit);
  let res = r / rangeExplicit;
  return res;
};

GatiServerGame.prototype.initServer = function (cb) {
  this.init(
    function () {
      cb();
    },
    function () {},
    undefined,
    "LEFT_TOP"
  );
};

GatiServerGame.prototype.updateCurrentStake = function (newStake) {
  if (this._stake != newStake) {
    this._stake = newStake;
    this._slotGame.getGameEventsEmitter().totalBetChanged(this._stake / 100);
  }
};

GatiServerGame.prototype.setBPL = function (bpl) {
  let baseStake = this._numLines * bpl;
  let newStake = baseStake;

  if (gameData.encoreEnabled) {
    newStake *= 1.5;
  }

  this.updateCurrentStake(newStake);
};

GatiServerGame.prototype.restorePreviousWagersDerived = function () {
  let res = this.restorePreviousWagersBase();

  if (
    this._previousWagers &&
    this._previousWagers.data &&
    this._previousWagers.data.length > 0 &&
    this._previousWagers.data[0].bets &&
    this._previousWagers.data[0].bets.length > 0 &&
    this._previousWagers.data[0].bets[0].betdata.cmd === "LUCKYBET_BUY"
  ) {
    this.setDefaultBet(res.baseStake);
  }
  return res;
};

GatiServerGame.prototype.addGameConfigToQueueDerived = function (loadData) {
  this.addGameConfigToQueueBase(loadData);

  let message = this._messageQueue[0];
  message.buyBonusCost = 100;

  gdk.addConfigValue(
    "AllowBuyBonus",
    message.slotConfig.gameModes["BONUS_BUY"] ? true : false
  );

  let configMessage = this._messageQueue[this._messageQueue.length - 1];

  this.cheatPanelActive = loadData.customParameters.cheatPanel === "yes";

  gameData.license = loadData.customParameters.license;

  if (configMessage.slotConfig.gameModes.BONUS_BUY) {
    // This game mode can be disabled so need to check if exists
    this.freeSpinsCostMultiplier =
      configMessage.slotConfig.gameModes.BONUS_BUY.coinsPerBet / 10;
  }

  gameData.recoveryStake = undefined;
  configMessage.slotConfig.coins = 10; // purely paytable
  configMessage.maxExposure = loadData.settings.slotConfig.MaxExposure;

  this.luckyBetCostMultiplier =
    configMessage.slotConfig.gameModes.LUCKYBET_BUY.coinsPerBet;

  configMessage.buyBonusCostFreeSpins = this.freeSpinsCostMultiplier;
  configMessage.buyLuckyBet = this.luckyBetCostMultiplier;

  if (
    configMessage.slotConfig.gameModes["BONUS_BUY"] ||
    configMessage.slotConfig.gameModes["LUCKYBET_BUY"]
  ) {
    allowBonusBuy = true;
  }

  if (
    loadData.customParameters.buyBonusDisabled === "yes" ||
    loadData.customParameters.buyBonusDisabled === "Yes" ||
    loadData.customParameters.license === "uk" ||
    loadData.customParameters.license === "fin" ||
    loadData.customParameters.license === "lt" ||
    loadData.customParameters.license === "nl" ||
    loadData.customParameters.license === "de"
  ) {
    allowBonusBuy = false;
  }

  if (loadData.wagers.data.length) {
    let betData = loadData.wagers.data[0].bets[0].betdata;
    let stake = Number(betData.coin * 1000);
    gameData.recoveryStake = stake;

    if (betData.cmd === "LUCKYBET_BUY" || betData.cmd === "LUCKYBET_MAX_BUY") {
      gameData.recoveryStake *= 15;
      configMessage.slotConfig.recoverGB = true;
    } else {
      const findStake = configMessage.slotConfig.coinSizes.find(
        (coinSize) =>
          coinSize === stake / configMessage.slotConfig.defaultNumLines
      );

      if (!findStake) {
        gameData.recoveryStake =
          configMessage.slotConfig.coinSizes[0] *
          configMessage.slotConfig.defaultNumLines;
      }
    }
  }

  gdk.addConfigValue("AllowBuyBonus", allowBonusBuy ? true : false);
};

GatiServerGame.prototype.addRecoveryToQueueDerived = function () {
  for (let i = 0; i < this._latestEngineReponse.wager.bets.length; ++i) {
    let bet = this._latestEngineReponse.wager.bets[i];

    switch (bet.betdata.cmd) {
      default:
        break;

      case "BASIC_MAX":
        this._inMaxPlay = true;
        this._meta = {
          name: "max",
          value: true,
        };
        break;

      case "LUCKYBET_BUY":
        gameData.encoreEnabled = true;
        this._inLuckyBet = true;
        this._meta = {
          name: "lucky",
          value: true,
        };
        break;

      case "LUCKYBET_MAX_BUY":
        gameData.encoreEnabled = true;
        this._inMaxPlay = true;
        this._inLuckyBet = true;
        this._meta = {
          name: "lucky_max",
          value: true,
        };
        break;

      case "BONUS_BUY":
        gameData.buyBonus = true;
        this._inBuyABonus = true;
        this._meta = {
          name: "buyABonusFreeSpins",
          value: true,
        };
        break;
    }
  }
  this.addRecoveryToQueueBase();
};

GatiServerGame.prototype.startGameDerived = function (stakeData, cb) {
  this._inBuyABonus = stakeData.metaData.buyABonus;
  this._inLuckyBet = stakeData.metaData.encore;
  this._inMaxPlay = stakeData.metaData.maxPlay;

  this.gambleForce = undefined;
  this.getGambleForce = false;

  if (this._forces === undefined || !this._forces) {
    this._forces = "";
    this.addCheatToRequest(stakeData, this._forces);
  }

  this.startGameBase(stakeData, cb);
};

GatiServerGame.prototype.addMetaDataToSpinRequest = function (request) {
  this._coinValue = 10;
  let stakeController = resourceManager.getController("stakeController");
  let baseStake = stakeController.getBaseStake("default") / 100;

  request.coin = request.amount / this._coinValue;
  request.coins = this._coinValue;

  if (this._forces === "" && this.cheatPanelActive) {
    request.cheat = JSON.stringify(null);
  }

  request.clientParams = JSON.stringify({
    Params: {
      mode: gameController.gambleModeIndex,
      maxplay: gameController.maxPlayActive,
    },
  });

  if (this._inLuckyBet) {
    this._coinValue = 100;
    request.amount = baseStake * 1.5;
    request.coin = baseStake / this._coinValue;
    request.coins = this.luckyBetCostMultiplier;

    if (this._inMaxPlay) {
      request.cmd = "LUCKYBET_MAX_BUY";
    } else {
      request.cmd = "LUCKYBET_BUY";
    }
  } else if (this._inBuyABonus) {
    baseStake = stakeController.getBaseStake("BONUS_BUY") / 100;
    request.amount = baseStake * this.freeSpinsCostMultiplier;
    request.coin = baseStake / this._coinValue;
    request.cmd = "BONUS_BUY";
  } else if (this._inMaxPlay) {
    request.cmd = "BASIC_MAX";
  }
};

GatiServerGame.prototype.addFSStartToQueue = function () {
  this.fsWinnings = 0;
  var message = {};

  message.type = "spinner:FreeSpinsStartEvent";
  message.freeSpinsAwarded = this._initialFreeSpins;
  message.initialTrailLevel = this._initialTrailLevel;
  message.bonusWin = 0;

  this.inGamble = false;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addFSDataToQueue = function () {
  let message = {};
  message.type = "spinner:FreeSpinsDataEvent";
  message.num = this.fsCount + 1;
  message.fsWinnings = this.fsWinnings;
  message.trailPosition = this._trailPosition;
  message.trailLevel = this._trailLevel;
  message.trailPositionIncreased = this._trailPositionIncreased;
  message.respinsAdded = this.respinsAdded;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addFSEndToQueue = function (winnings, isCapped) {
  let message = {};
  message.type = "spinner:FreeSpinsEndEvent";
  message.fsWinnings = winnings;
  message.totalWinnings = this._totalWinnings;
  message.isBigWin = false;
  message.isCapped = isCapped;
  this.fsWinnings = 0;
  this.inFS = false;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.shuffleArray = function (array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
};

GatiServerGame.prototype.getSpinData = function (cb, data) {
  let parts = data.Parts;
  this._forces = "";

  if (this.inFS) {
    this.getSpinDataFS(parts[1], cb);
    return;
  }

  let totalWon = 0;

  for (let i = 0; i < parts.length; ++i) {
    let type = parts[i].type;
    this._localRngSeed = -1;

    if (type === "baseGame") {
      this._finalBaseWinnings = parts[0].winAmount;
      this._localRngSeed = data.ResultId;

      totalWon += this.getSpinDataNormal(parts[i]);

      if (parts[i].respin.isAwarded) {
        this.addRespinDataToQueue(parts[i].respin);
      }

      if (parts.length === 1) {
        this.addGameCompleteToQueue(totalWon);
      }
    } else if (type === "gambleStart") {
      this.addGambleDataToQueue(parts[i]);
      this.inGamble = true;
    } else if (type === "gambleResult") {
      switch (parts[i].resultKind) {
        default:
          this.addGambleResultToQueue(parts[i]);
          this._totalWinnings = parts[i].currentCashWin;
          break;

        case 0:
        case 1:
          this.inGamble = false;
          this._totalWinnings = parts[i].currentCashWin;
          this.addGambleResultToQueue(parts[i]);
          this.addGameCompleteToQueue(this._totalWinnings);
          break;

        case 2:
          this.inGamble = false;
          this.addGameCompleteToQueue(this._totalWinnings);
          break;

        case 3:
          this.inGamble = false;
          this._totalWinnings = 0;
          this._finalBaseWinnings = 0;
          break;

        case 4:
          const cashOptionsMaxed = parts[i].cashGambleOptions.length === 0;
          const bonusOptionsMaxed = parts[i].bonusGambleOptions.length === 0;
          const capped = cashOptionsMaxed && bonusOptionsMaxed;
          this.addGambleResultToQueue(parts[i], capped);
          break;
      }
    } else if (type === "freeSpins") {
      this.inGamble = false;
      this.inFS = true;
      this.fsCount = 0;
      this.freeSpins = parts[i].spins;
      this._finalFsWinnings = parts[i].winAmount;
      this._initialFreeSpins = parts[i].initialNumberOfSpins;
      this._initialTrailLevel = parts[i].initialTrailLevel;
      this._totalWinnings = this._finalBaseWinnings + this._finalFsWinnings;

      this.addFSStartToQueue();
    }
  }

  if (cb != undefined) {
    cb();
  }
  this.triggerNextMessage();
};

GatiServerGame.prototype.processModifiers = function (data, spinEvent) {};

GatiServerGame.prototype.addModifiersToQueue = function (data, cloneReal) {};

GatiServerGame.prototype.hasModifier = function (data) {};

GatiServerGame.prototype.addWinnings = function (winningLinesData) {
  this.addWinningsToQueue(winningLinesData);
};

GatiServerGame.prototype.addSpinDataToQueue = function (
  event,
  fishData,
  fishWinAmount,
  finalFreeSpin,
  lockedFishermen,
  fishermenAwards,
  fishermenInView,
  hookData,
  respinData
) {
  var message = {};
  message.type = "spinner:SpinEvent";

  message.baseBet = this._stake;
  message.betMultiplier = 1;
  message.resultPanel = {};
  message.isPrePaidGame = this._isPrePaidGame;
  message.resultPanel.reels = 5;
  message.resultPanel.rectangular = true;
  message.finalFreeSpin = finalFreeSpin;
  message.resultPanel.reelList = event.reelList;
  message.resultPanel.symbolsAbove = event.symbolsAbove;
  message.resultPanel.symbolsBelow = event.symbolsBelow;
  message.fishData = fishData;
  message.fishermenAwards = fishermenAwards;
  message.fishermenInView = fishermenInView;
  message.fishWinAmount = fishWinAmount;
  message.lockedFishermen = lockedFishermen;
  message.hookData = hookData;
  message.respinData = respinData;

  if (this._localRngSeed !== -1) {
    message.localRng = this._localRngSeed;
  }

  this._messageQueue.push(message);
  return message;
};

GatiServerGame.prototype.getSpinDataGeneric = function (
  spinEvent,
  data,
  freeSpinsActive,
  cb
) {
  let isCapped = data.winCapped;
  let finalFreeSpin = false;
  let lockedFishermen = [];

  if (freeSpinsActive) {
    if (this.freeSpins.length === this.fsCount) {
      finalFreeSpin = true;
    }

    this._trailPositionIncreased =
      this._trailPosition !== data.trailPositionAtEnd;
    this._trailPosition = data.trailPositionAtEnd;
    this._trailLevel = data.trailLevelAtEnd;

    gameController.trailLevel = this._trailLevel;

    lockedFishermen = data.lockedFishermenAtEnd;
  }

  let fishData = data.fishs;
  let fishermenAwards = data.fishermenAwards;
  let fishermenInView = data.fishermen;
  let fishWinAmount = 0;
  let hookData = data.hook;
  let respinData = data.respin;

  for (let i = 0; i < fishermenAwards.fish.length; i++) {
    fishWinAmount += fishermenAwards.fish[i].winAmount;
  }

  const inFS = gameController.boughtBonus || gameController.inFreeSpins;

  let stake = inFS
    ? gameController.getCurrentModeStake()
    : gameController.globalHelperGetBaseStake();
  let winningLinesEvent = data.payLines;

  //If buying a bonus in maxplay, replace landing symbols
  //#region
  if (this._inBuyABonus && gameController.inMaxPlay) {
    for (let i = 0; i < spinEvent.reelList.length; i++) {
      const symbols = spinEvent.reelList[i].symbols;

      for (let j = 0; j < symbols.length; j++) {
        const symbol = symbols[j].value;

        if ((symbol >= 1 && symbol <= 4) || (symbol >= 12 && symbol <= 16)) {
          spinEvent.reelList[i].symbols[j].value = 18;
        }
      }
    }

    this._inMaxPlay = false;
  }
  //#endregion

  //Amend symbols for fishermen if they have a multiplier
  //Fishermen that have previously landed and locked are given a random replacement symbol
  //#region
  if (fishermenInView) {
    for (let i = 0; i < fishermenInView.length; i++) {
      const fisherman = fishermenInView[i];
      const multi = fisherman.multiplier;
      const reel = fisherman.coord.reel;
      const row = fisherman.coord.row;

      const crtSymbol = spinEvent.reelList[reel].symbols[row].value;

      if (crtSymbol !== 0) {
        break;
      }

      let newSym = 0;

      //Check if not a replacement symbol

      switch (multi) {
        case 2:
          newSym = 33;
          break;

        case 3:
          newSym = 34;
          break;

        case 5:
          newSym = 35;
          break;

        case 10:
          newSym = 36;
          break;
      }

      if (newSym !== 0) {
        spinEvent.reelList[reel].symbols[row].value = newSym;
      }
    }
  }
  //#endregion

  //Amend symbols for fish depending on their value
  //#region
  for (let i = 0; i < fishData.length; i++) {
    const fish = fishData[i];
    const baseVal = fish.amount;
    const value = baseVal / stake;
    const sym = fish.symbol;
    const reel = fish.coord.reel;
    const row = fish.coord.row;

    this.getNewFish(sym, value, spinEvent, reel, row, fish);
  }

  if (respinData?.newfish !== undefined) {
    for (let i = 0; i < respinData.newfish.length; i++) {
      const fish = respinData.newfish[i];
      const baseVal = fish.amount;
      const value = baseVal / stake;
      const sym = fish.symbol;
      const reel = fish.coord.reel;
      const row = fish.coord.row;

      this.getNewFish(sym, value, respinData.finalStopWindow, reel, row);
    }
  }
  //#endregion

  this.addSpinDataToQueue(
    spinEvent,
    fishData,
    fishWinAmount,
    finalFreeSpin,
    lockedFishermen,
    fishermenAwards,
    fishermenInView,
    hookData,
    respinData
  );

  if (
    winningLinesEvent.winningLines.length > 0 ||
    fishermenAwards.winAmount > 0
  ) {
    if (respinData?.isAwarded) {
      winningLinesEvent.totalLineWinnings -= respinData.winAmount;
    }

    this.addWinnings(winningLinesEvent);
    const message = this._messageQueue[this._messageQueue.length - 1];
    message.isCapped = isCapped;
  }

  if (freeSpinsActive) {
    this.fsWinnings += data.winAmount;
    this.respinsAdded = data.spinsAdded;

    if (this.fsCount < this.freeSpins.length) {
      this.addFSDataToQueue();
    } else {
      this.addFSEndToQueue(this.fsWinnings, data, isCapped);
      this.addGameCompleteToQueue(this.fsWinnings);
      this.inFS = false;
    }

    if (this.respinsAdded !== 0 && !isCapped) {
      this.addRetriggerToQueue(this.respinsAdded);
    }

    if (cb != undefined) {
      cb();
    }
    this.triggerNextMessage();
  } else {
    return data.winAmount;
  }
};

GatiServerGame.prototype.getNewFish = function (
  symbol,
  value,
  event,
  reel,
  row,
  fishData = undefined
) {
  let newSym = symbol;

  switch (symbol) {
    case 5:
      switch (value) {
        case 200:
          newSym = 23;
          break;

        case 500:
          newSym = 24;
          break;

        case 5000:
          newSym = 25;
          break;
      }
      break;

    case 6:
      switch (value) {
        case 35:
          newSym = 26;
          break;

        case 50:
          newSym = 27;
          break;
      }
      break;

    case 7:
      if (value === 20) {
        newSym = 28;
      }
      break;

    case 8:
      if (value === 10) {
        newSym = 29;
      }
      break;

    case 9:
      if (value === 6) {
        newSym = 30;
      }
      break;

    case 10:
      if (value === 4) {
        newSym = 31;
      }
      break;

    case 11:
      if (value === 2) {
        newSym = 32;
      }
      break;
  }

  if (fishData !== undefined) {
    fishData.symbol = newSym;
  }

  event.reelList[reel].symbols[row].value = newSym;
};

GatiServerGame.prototype.getSpinDataNormal = function (data) {
  let spinEvent = data.stopWindow;
  let winningLinesEvent = data.payLines;

  if (!this.validateResponse(spinEvent)) return;
  if (!this.validateResponse(winningLinesEvent)) return;

  return this.getSpinDataGeneric(spinEvent, data, false, function () {});
};

GatiServerGame.prototype.getSpinDataFS = function (data, cb) {
  let thisFsOutcome = data.spins[this.fsCount++];
  let spinEvent = thisFsOutcome.stopWindow;

  this.getSpinDataGeneric(spinEvent, thisFsOutcome, true, cb);
};

GatiServerGame.prototype.sendGambleResponseToServer = function (response, cb) {
  if (this._gameNotFullyRecovered) {
    // no need to send state, already done and part of recovery
    this.moveToNextBetData();
    messageBus.postImmediate("Gamble:HandledCommand");
    timerManager.addTimer(500, undefined, cb);
    return;
  }

  this.resetCurrentBetData();

  let self = this;

  let nextStep =
    this._latestEngineReponse.wager.bets[
      this._latestEngineReponse.wager.bets.length - 1
    ].step + 1;

  let playData = {
    cmd: response,
    step: nextStep,
    clientParams: "",
  };

  if (this.gambleForce !== undefined) {
    playData.cheat = JSON.stringify(this.gambleForce);
  }

  const sendCommand = async () => {
    self._latestEngineReponse = await self._slotGame.play(playData);
    self._forces = self.updateForces(self._forces);

    cb();
  };

  sendCommand().then(() => {
    if (response === "COLLECT") {
      messageBus.postImmediate("Gamble:Collect");
    } else {
      messageBus.postImmediate("spinner:GambleCommandSent");
    }
  });
};

GatiServerGame.prototype.addRespinDataToQueue = function (data) {
  var message = {};

  message.type = "spinner:RespinDataEvent";

  message.respinData = data;

  this._messageQueue.push(message);

  if (
    data.payLines.winningLines.length > 0 ||
    data.fishermenAwards.winAmount > 0
  ) {
    data.payLines.totalLineWinnings = data.winAmount;
    this.addWinnings(data.payLines);
    const payMessage = this._messageQueue[this._messageQueue.length - 1];
    payMessage.isCapped = data.winCapped;
  }
};

GatiServerGame.prototype.addGambleDataToQueue = function (data) {
  var message = {};

  message.type = "spinner:GambleDataEvent";

  message.isCapped = data.winCapped;
  message.bonusGambleOptions = data.bonusGambleOptions;
  message.cashGambleOptions = data.cashGambleOptions;
  message.collectionOptions = data.collectionOptions;

  let self = this;
  message.resultCallback = function (obj, cb) {
    self.sendGambleResponseToServer(obj.response, cb);
  };
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addFSAwardToQueue = function (freespinsAwarded) {
  var message = {};
  message.type = "spinner:FreeSpinsAwardEvent";
  message.freeSpinsAwarded = freespinsAwarded;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addGambleResultToQueue = function (
  result,
  winCapped = false
) {
  var message = {};
  message.type = "spinner:GambleResultEvent";
  message.bonusGambleOptions = result.bonusGambleOptions;
  message.cashGambleOptions = result.cashGambleOptions;
  message.otherGambleSpinStop = result.otherGambleSpinStop;
  message.won = result.currentCashWin;
  message.winCapped = winCapped;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addRetriggerToQueue = function (count) {
  let message = {};
  message.type = "spinner:FreeSpinsRetriggerEvent";
  message.num = count;
  message.trailLevel = this._trailLevel;
  this._messageQueue.push(message);
};

GatiServer.prototype.getCheatString = function () {
  return this.force;
};

GatiServer.prototype.logCheatString = function () {
  this.force =
    this._latestEngineReponse.wager.bets[0].eventdata?.response?.clientData?.Repro;

  if (this.getGambleForce) {
    this.getGambleForce = false;
  } else {
    this.gambleForce = undefined;
  }

  if (this.force === undefined || this.force !== "") {
    console.log("force: " + this.force);
  }
};

GatiServer.prototype.addCheatToRequest = function (request, forces, index = 0) {
  let forcesJson = forces;

  if (!forcesJson || forcesJson.length === 0) return;

  if (forces[1] !== undefined && this._stake === 100) {
    const len = forces[1].r.length;

    if (forces[1].r[len - 1] === 0) {
      this.gambleForce = forces[1];
      this.getGambleForce = true;
    } else {
      this.gambleForce = undefined;
    }
  } else {
    this.gambleForce = undefined;
  }

  let nextCheatStr = JSON.stringify(forcesJson[index]);
  request.cheat = nextCheatStr;
};

GatiServer.prototype.updateForces = function (forces) {
  return undefined;
};
